<ion-content class="funding-screen tw-pt-[16px] tw-pb-[16px] tw-pr-[30px] tw-pl-[30px]" data-cy="funding-screen">

  <!-- Heading -->
  <div class="heading-section tw-relative">
    <div class="head-row tw-relative">
      <ion-icon
        name="arrow-back-outline"
        (click)="close()"
        class="soft-back tw-text-[20px] tw-text-white tw-p-[5px] tw-absolute"
      />
      <ion-title class="tw-text-center"
        class="
        tw-text-center
        tw-text-[20px]
        tw-font-bold
      ">
        Funding
      </ion-title>
      <span
        (click)="close()"
        class="
        close
        tw-absolute
        tw-capitalize
        tw-text-[16px]
      "
      data-cy="funding-close">
        Close
      </span>
    </div>
    <div class="deposit-withdraw-row tw-flex">
      <div (click)="depositTab($event, 'deposit')" class="content deposit tw-text-center">
        <p class="title tw-text-[16px]" data-cy="funding-deposit-header">Deposit</p>
        <div class="tab active"></div>
      </div>
      <div
        [hidden]="affiliateName.toLowerCase() === 'nhplay'"
        (click)="withdrawTab($event, 'withdraw')"
        class="content withdraw tw-text-center"
      >
        <p class="title tw-text-[16px]" data-cy="funding-withdraw-header">Withdraw</p>
        <div class="tab"></div>
      </div>
    </div>
  </div>

  <div class="mid-line"></div>


  <!-- Deposit -->
  <div *ngIf="showDepositList" class="my-deposit-section">

    <!-- Options -->
    <div>
      <!-- Debit and Credit Card -->
      <div
        (click)="selectCard('debitAndCreditCard')"
        class="debitAndCreditCard deposit-row"
        data-name="debitAndCreditCard"
        data-cy="dep-card-cont"
      >
        <img
          src="/assets/images/funding/visa_mastercard_logo.png"
          class="tw-inline-block tw-mr-[10%]"
          width="91"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-card">
          Debit and Credit Card
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Crypto Currency -->
      <div
        (click)="selectCard('cryptoCurrency')"
        class="cryptoCurrency deposit-row"
        data-name="cryptoCurrency"
        data-cy="dep-crypto-cont"
      >
        <img
          src="/assets/images/funding/crypto_currency_logo.png"
          class="tw-inline-block tw-mr-[11%]"
          width="88"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-crypto"
        >
          Crypto Currency
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Online Check -->
      <div
        *ngIf="affiliateName.toLowerCase() !== 'nhplay'"
        (click)="selectCard('onlineCheck')"
        class="onlineCheck deposit-row"
        data-name="onlineCheck"
        data-cy="dep-ach-cont"
      >
        <img
          src="/assets/images/funding/ach_logo.png"
          class="tw-inline-block tw-mr-[11%]"
          width="99"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-ach"
        >
          Online Check (ACH)
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- NH Play -->
      <div
        *ngIf="affiliateName.toLowerCase() === 'nhplay'"
        (click)="selectCard('nhPlay')"
        class="nhPlay deposit-row"
        data-name="nhPlay"
      >
        <img
          src="/assets/images/funding/nh_play_logo.png"
          class="tw-inline-block tw-mr-[11%]"
          width="99"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-ach"
        >
          NH Play Account
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
      </div>

      <!-- Pay Near Me -->
      <div
        (click)="selectCard('payNearMe')"
        class="payNearMe deposit-row"
        data-name="payNearMe"
        data-cy="dep-paynearme-cont"
      >
        <img
          src="/assets/images/funding/pay_near_me_logo.png"
          class="tw-relative tw-left-[-11px] tw-inline-block tw-mr-[1%]"
          width="127"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-paynearme"
        >
          PayNearMe
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
        <feature-ion-pay-near-me></feature-ion-pay-near-me>
      </div>

      <!-- MoneyPak -->
      <div
        (click)="selectCard('moneyPak')"
        class="moneyPak deposit-row"
        data-name="moneyPak"
        data-cy="dep-moneypak-cont"
      >
        <img
          src="/assets/images/funding/money_pak_logo.png"
          class="tw-inline-block tw-mr-[9%]"
          width="104"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-moneypak"
        >
          MoneyPak
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Wire Transfer -->
      <div
        (click)="selectCard('wireTransfer')"
        class="wireTransfer deposit-row"
        data-name="wireTransfer"
        data-cy="dep-wire-cont"
      >
        <img
          src="/assets/images/funding/wire_transfer_logo.png"
          class="tw-inline-block tw-mr-[12%]"
          width="91"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-wire"
        >
          Wire Transfer
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Check Money Order -->
      <div
       (click)="selectCard('checkMoneyOrder')"
        class="checkMoneyOrder deposit-row"
        data-name="checkMoneyOrder"
        data-cy="dep-moneyOrder-cont"
      >
        <img
          src="/assets/images/funding/check_money_order_logo.png"
          class="tw-inline-block tw-mr-[11.5%]"
          width="95"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-money-order"
        >
          Check / Money Order
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Promo Code -->
      <div
       (click)="selectCard('promoCode')"
        class="promoCode deposit-row"
        data-name="promoCode"
        data-cy="funding-deposit-promo-code"
      >
        <img
          src="/assets/images/funding/promo_code_logo.png"
          class="tw-inline tw-mr-[19%] tw-ml-[3%]"
          width="63"
        >
        <span slot="start" class="tw-font-bold tw-text-[16px]">Promo Code</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>
    </div>


    <!-- Dynamic Content -->
    <div class="content">
      <!-- Debit and Credit Card -->
      <div class="debitAndCreditCard card-content card-hide" data-name="debitAndCreditCard">
        <feature-ion-debit-credit-card *ngIf="controller.debitAndCreditCard">
        </feature-ion-debit-credit-card>
      </div>

      <!-- Crypto Currency -->
      <div class="cryptoCurrency card-content card-hide" data-name="cryptoCurrency">
        <feature-ion-crypto-currency
          *ngIf="controller.cryptoCurrency"
          data-cy="deposit-crypto-screen"
        >
        </feature-ion-crypto-currency>
      </div>

      <!-- Online Check -->
      <div class="onlineCheck card-content card-hide" data-name="onlineCheck">
        <feature-ion-online-check-deposit
          *ngIf="controller.onlineCheck"
          data-cy="deposit-ach-screen"
        >
        </feature-ion-online-check-deposit>
      </div>

      <!-- Pay Near Me -->
      <div class="payNearMe card-content card-hide" data-name="payNearMe">
        <p *ngIf="controller.payNearMe" data-cy="deposit-paynearme-screen">payNearMe</p>
      </div>

      <!-- moneyPak -->
      <div class="moneyPak card-content card-hide" data-name="moneyPak">
        <feature-ion-money-pak
          *ngIf="controller.moneyPak"
          data-cy="deposit-moneypak-screen"
        >
        </feature-ion-money-pak>
      </div>

      <!-- Wire Transfer -->
      <div class="wireTransfer card-content card-hide" data-name="wireTransfer">
        <feature-ion-wire-transfer
          *ngIf="controller.wireTransfer"
          data-cy="deposit-wire-screen"
        >
        </feature-ion-wire-transfer>
      </div>

      <!-- Check Money Order -->
      <div class="checkMoneyOrder card-content card-hide" data-name="checkMoneyOrder">
        <p *ngIf="controller.checkMoneyOrder" data-cy="deposit-money-order-screen">
          checkMoneyOrder
        </p>
      </div>

      <!-- Promo Code -->
      <div class="promoCode card-content card-hide" data-name="promoCode">
        <feature-ion-promo-code *ngIf="controller.promoCode"></feature-ion-promo-code>
      </div>
    </div>

  </div>

  <!-- Withdraw -->
  <div *ngIf="showWithdrawList" class="my-deposit-section">

    <!-- Options -->
    <div>
      <!-- Debit and Credit Card -->
      <div
        (click)="selectCard('debitAndCreditCard')"
        class="debitAndCreditCard deposit-row"
        data-name="debitAndCreditCard"
        data-cy="wdraw-card-cont"
      >
        <img
          src="/assets/images/funding/visa_mastercard_logo.png"
          class="tw-inline-block tw-mr-[10%]"
          width="91"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-withdraw-card">
          Debit and Credit Card
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Online Check -->
      <div
        (click)="selectCard('onlineCheck')"
        class="onlineCheck deposit-row"
        data-name="onlineCheck"
        data-cy="wdraw-ach-cont"
      >
        <img
          src="/assets/images/funding/ach_logo.png"
          class="tw-inline-block tw-mr-[11%]"
          width="99"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-deposit-ach"
        >
          Online Check (ACH)
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Check Money Order -->
      <div
       (click)="selectCard('checkByEmail')"
        class="checkByEmail deposit-row"
        data-name="checkByEmail"
        data-cy="wdraw-chkByMail-cont"
      >
        <img
          src="/assets/images/funding/check_money_order_logo.png"
          class="tw-inline-block tw-mr-[11.5%]"
          width="95"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-withdraw-check-by-mail"
        >
          Check By Mail
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>

      <!-- Wire Transfer -->
      <div
        (click)="selectCard('wireTransfer')"
        class="wireTransfer deposit-row"
        data-name="wireTransfer"
        data-cy="wdraw-wire-cont"
      >
        <img
          src="/assets/images/funding/wire_transfer_logo.png"
          class="tw-inline-block tw-mr-[12%]"
          width="91"
        >
        <span
          slot="start"
          class="tw-inline-block tw-font-bold tw-text-[16px]"
          data-cy="funding-withdraw-wire"
        >
          Wire Transfer
        </span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right">
        </ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right"></ion-icon>
      </div>
    </div>


    <!-- Dynamic Content -->
    <div class="content">
      <!-- Debit and Credit Card -->
      <div class="debitAndCreditCard card-content card-hide" data-name="debitAndCreditCard">
        <feature-ion-withdraw-debit-credit-card *ngIf="controller.debitAndCreditCard">
        </feature-ion-withdraw-debit-credit-card>
      </div>

      <!-- Online Check -->
      <div class="onlineCheck card-content card-hide" data-name="onlineCheck">
        <feature-ion-online-check-withdraw *ngIf="controller.onlineCheck" data-cy="deposit-ach-screen">
        </feature-ion-online-check-withdraw>
      </div>

      <!-- Check Money Order -->
      <div class="checkByEmail card-content card-hide" data-name="checkByEmail">
        <feature-ion-check-by-email
          *ngIf="controller.checkByEmail"
          data-cy="withdraw-check-by-email-screen"
        >
        </feature-ion-check-by-email>
      </div>

      <!-- Wire Transfer -->
      <div class="wireTransfer card-content card-hide" data-name="wireTransfer">
        <feature-ion-withdraw-wire-transfer
          *ngIf="controller.wireTransfer"
          data-cy="deposit-wire-screen"
        >
        </feature-ion-withdraw-wire-transfer>
      </div>
    </div>

  </div>

</ion-content>
